import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { AsyncRequestService } from 'src/app/core/async-request/async-request.service';
import { API_URL_COMPANIES } from 'src/app/shared/services/basic.service';
import { ErrorHandlingService } from 'src/app/shared/services/error-handling.service';
import { MediasService } from 'src/app/shared/services/medias.service';
import { LoggedUser, TaskDetailsRaw } from '../shared/models';

@Injectable({
  providedIn: 'root',
})
export class LoggedUsersService {
  constructor(
    private alcmeonContext: AlcmeonContextService,
    private asyncRequestService: AsyncRequestService,
    private errorHandlingService: ErrorHandlingService,
    private httpClient: HttpClient,
    private mediasService: MediasService
  ) {}

  getlist(): Observable<LoggedUser[]> {
    return this.httpClient
      .get<any>(`${API_URL_COMPANIES}/${this.alcmeonContext.companyId}/admin-user/list-currently-logged`)
      .pipe(
        map(response => response.currentlyLoggedAdminUsers),
        this.errorHandlingService.catchAlertAndThrowHttpError()
      );
  }

  disconnectUser(userId: number): Observable<any> {
    return this.httpClient
      .post<any>(`${API_URL_COMPANIES}/${this.alcmeonContext.companyId}/admin-user/disconnect/${userId}`, {})
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  createExport(users: LoggedUser[]) {
    this.asyncRequestService
      .post<any>(`${API_URL_COMPANIES}/${this.alcmeonContext.companyId}/admin-user/export-currently-logged`, users)
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError())
      .subscribe({
        next: (data: any) => {
          const { content, content_type, content_filename } = data;
          this.mediasService.downloadBinaryBase64(content, content_type, content_filename);
        },
      });
  }

  createTaskDetailsJson(tasks: number[]): Observable<TaskDetailsRaw> {
    return this.asyncRequestService
      .post<TaskDetailsRaw>(`${API_URL_COMPANIES}/${this.alcmeonContext.companyId}/tasks/export-details/json`, tasks)
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  createTaskDetailsExport(tasks: number[]) {
    return this.asyncRequestService
      .post<any>(`${API_URL_COMPANIES}/${this.alcmeonContext.companyId}/tasks/export-details/xlsx`, tasks)
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError())
      .subscribe({
        next: (data: any) => {
          const { content, content_type, content_filename } = data;
          this.mediasService.downloadBinaryBase64(content, content_type, content_filename);
        },
      });
  }
}
